// src/pages/Delivery/Delivery.jsx
//
// ДОСТАВКА И ОПЛАТА.
//
// 🔴 ЧТО БЫЛО НЕ ТАК (исправлено 2026-10-07).
//    Страница утверждала то, чего нет, — а это хуже отсутствия страницы:
//    клиент рассчитывает на условия, которых мы не выполним.
//
//    1. «Курьерская доставка по Москве — от 500 ₽».
//       Магазин работает в СТАРОМ ОСКОЛЕ (адрес в ЕГРИП: Белгородская
//       область, г. Старый Оскол). Москвы тут нет вовсе.
//
//    2. «Оплата картой онлайн». Такой оплаты НЕТ: платёжный провайдер не
//       подключён (проверено: ноль совпадений по yookassa/stripe/tinkoff/
//       robokassa в коде). Заказ создаётся со `payment_status = 'pending'`,
//       а оплату вручную отмечает администратор.
//       📌 Оплата — в техдолге (см. SHOP_ROADMAP.txt §5).
//
//    3. Стоимость доставки. В коде `delivery_cost` захардкожен в 0
//       (`orderController.js`), то есть доставка сейчас НЕ рассчитывается
//       и НЕ прибавляется к итогу. Поэтому конкретные суммы здесь не
//       обещаем — согласуем с менеджером при подтверждении заказа.
//
// ⚠️ СУММЫ НЕ ВЫДУМЫВАЕМ. Если написать «от 500 ₽», а в заказе прибавится
//    0 ₽ — это обман покупателя (ст. 10 ЗоЗПП: право на достоверную
//    информацию). Пусть лучше будет «рассчитывается индивидуально».
import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs';
import { REQUISITES } from '../../utils/requisites.js';

export const Delivery = () => {
  const breadcrumbs = [{ label: 'Доставка и оплата', path: '/delivery' }];

  const sectionStyle = { fontWeight: 600, marginTop: '24px', marginBottom: '8px' };
  const listStyle = { color: 'rgb(var(--c-text-secondary))', lineHeight: 1.9, paddingLeft: '20px' };
  const noteStyle = {
    backgroundColor: '#F5F8FC',
    border: '1px solid #DCE7F5',
    borderRadius: '8px',
    padding: '14px 16px',
    fontSize: '14px',
    color: '#33475B',
    lineHeight: 1.6,
    marginTop: '16px',
  };

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '60px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />
        <h1 style={{
          fontSize: '32px',
          fontWeight: 700,
          color: 'rgb(var(--c-text))',
          marginTop: '24px',
          marginBottom: '8px',
        }}>
          Доставка и оплата
        </h1>
        <p style={{ color: 'rgb(var(--c-text-secondary))', fontSize: '15px', marginBottom: '8px' }}>
          Мы находимся в {REQUISITES.city.replace('г. ', 'г. ')}
          {' '}({REQUISITES.region}) и работаем по всей России.
        </p>

        <div style={{ maxWidth: '800px' }}>
          <h3 style={sectionStyle}>Способы получения</h3>
          <ul style={listStyle}>
            <li>
              <strong>Самовывоз</strong> из цеха в {REQUISITES.city} — бесплатно.
              Точный адрес и время согласуем при подтверждении заказа.
            </li>
            <li>
              <strong>Доставка по {REQUISITES.city} и району</strong> — стоимость
              рассчитывается индивидуально, зависит от габаритов изделия.
            </li>
            <li>
              <strong>Транспортными компаниями по России</strong> — СДЭК, Деловые
              линии, Почта России. Отправляем после изготовления и согласования
              макета.
            </li>
          </ul>

          <h3 style={sectionStyle}>Стоимость доставки</h3>
          <p style={{ color: 'rgb(var(--c-text-secondary))', lineHeight: 1.8 }}>
            Стоимость зависит от размеров изделия, адреса и выбранной
            транспортной компании. Мы называем её <strong>до подтверждения
            заказа</strong>: менеджер связывается с вами, уточняет детали и
            согласовывает итоговую сумму.
          </p>
          <div style={noteStyle}>
            Крупногабаритные изделия (вывески, объёмные буквы, баннеры большого
            формата) требуют отдельного расчёта — цена зависит от веса и
            габаритов, а не только от расстояния.
          </div>

          <h3 style={sectionStyle}>Способы оплаты</h3>
          <ul style={listStyle}>
            <li>
              <strong>Наличными</strong> при получении.
            </li>
            <li>
              <strong>Переводом на счёт</strong> (для физических лиц).
            </li>
            <li>
              <strong>Безналичный расчёт</strong> для юридических лиц и ИП —
              счёт и закрывающие документы.
            </li>
          </ul>

          <div style={{ ...noteStyle, backgroundColor: '#FFFBF0', borderColor: '#F5E0B8', color: '#6B5322' }}>
            ⚠️ <strong>Онлайн-оплата картой пока не подключена.</strong> Мы
            работаем над этим. Сейчас заказ оформляется как заявка: менеджер
            связывается с вами, подтверждает состав и сумму, после чего вы
            выбираете удобный способ оплаты.
          </div>

          <h3 style={sectionStyle}>Вопросы</h3>
          <p style={{ color: 'rgb(var(--c-text-secondary))', lineHeight: 1.8 }}>
            Телефон: <a href={REQUISITES.phoneHref} style={{ color: 'rgb(var(--c-accent))' }}>{REQUISITES.phone}</a>
            <br />
            Email: <a href={`mailto:${REQUISITES.email}`} style={{ color: 'rgb(var(--c-accent))' }}>{REQUISITES.email}</a>
            <br />
            Условия возврата — на странице{' '}
            <Link to="/returns" style={{ color: 'rgb(var(--c-accent))' }}>Возврат</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};
